<template>
  <div>
    <div v-if="status == 'PersonInfo'">
      <ion-grid>
        <ion-row>
          <ion-col> </ion-col>
          <ion-col> </ion-col>
          <ion-col class="ion-text-end">
            <ion-button class="button_nav wizbutton" @click="next"> Next </ion-button>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <div v-if="error!==''" class="login_error ion-text-center">{{ error }}</div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">First name</ion-label>
              <ion-input
                type="text"
                name="firstName"
                v-model="first_name"
              ></ion-input>
            </ion-item>
            <ion-text color="danger">
              <span class="">{{ first_name_error }}</span>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-label position="stacked">Last name</ion-label>
              <ion-input
                type="text"
                name="lastName"
                v-model="last_name"
              ></ion-input>
            </ion-item>
            <ion-text color="danger">
              <span class="">{{ last_name_error }}</span>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">Company</ion-label>
              <ion-input
                type="email"
                name="email"
                v-model="company"
              ></ion-input>
            </ion-item>
            <ion-text color="danger">
              <span class="">{{ company_error }}</span>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-label position="stacked">Phone</ion-label>
              <ion-input type="number" name="email" v-model="phone"></ion-input>
            </ion-item>
            <ion-text color="danger">
              <span class="">{{ phone_error }}</span>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-label position="stacked">Email</ion-label>
              <ion-input type="email" name="email" v-model="email"></ion-input>
            </ion-item>
            <ion-text color="danger">
              <span class="">{{ email_error }}</span>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-label position="stacked">Website</ion-label>
              <ion-input
                type="text"
                name="website"
                v-model="website"
              ></ion-input>
            </ion-item>
            <ion-text color="danger">
              <span class="">{{ website_error }}</span>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-button expand="block" @click="get_business_card">
              {{ get_business_card_message }}
            </ion-button>
          </ion-col>
        </ion-row>

        <ion-list>
          <ion-item v-for="(image, index) in images" :key="image">
            <ion-card class="text-center">
              <img style="height: auto" :src="image" />
              <ion-card-content style="text-right">
                <ion-button color="danger" size="small" @click="removePhoto(image,index)">Delete Photo</ion-button>
              </ion-card-content>
            </ion-card>
            <br />
          </ion-item>
        </ion-list>
      </ion-grid>
    </div>

    <div class="web-camera-container ion-text-center" v-if="status == 'Camera'">

      <div v-if="camera_error!==''" class="camera_error ion-text-center">{{ camera_error }}</div>

      <div class="camera-box" :class="{ flash: isShotPhoto }">
        <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

        <video
          v-show="!isPhotoTaken"
          ref="camera"
          style="width: 100%; height: 100%"
          autoplay
          muted
          playsinline
        ></video>

        <canvas
          v-show="isPhotoTaken"
          id="photoTaken"
          ref="canvas"
          style="width: 100%; height: 100%"
        ></canvas>
      </div>

      <div class="camera-shoot">
        <ion-row>
          <ion-col size="3">
            <ion-button size="small" @click="switchCamera" >
              Switch
            </ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button type="button" class="button" @click="takePhoto"
              >Shoot!</ion-button
            >
          </ion-col>
          <ion-col size="3">
            <ion-button size="small" type="button" class="button" @click="cancelCamera"
              >Cancel</ion-button
            >
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  IonInput,
  IonLabel,
  IonItem,
  IonRow,
  IonCol,
  IonText,
  IonButton,
  IonCard,
  IonCardContent
} from "@ionic/vue";

export default {
  name: "VisitorForm",

  components: {
    IonText,
    IonItem,
    IonLabel,
    IonInput,
    IonRow,
    IonCol,
    IonButton,
    IonCard,
    IonCardContent
  },

  data() {
    return {
      error: "",
      showNext: false,
      status: "PersonInfo",

      first_name: "",
      first_name_error: "",
      last_name: "",
      last_name_error: "",
      company: "",
      company_error: "",
      phone: "",
      phone_error: "",
      email: "",
      email_error: "",
      website: "",
      website_error: "",
      images: "",

      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      get_business_card_message: "Take Photo of Business Card",
      listOfCameras:[],
      selectedCameraIndex:0,
      firstUse:true,
      MediaStreamHelper:{}


    };
  },

  methods: {
    async next() {
      if (
        this.first_name == "" &&
        this.last_name == "" &&
        this.company == "" &&
        this.phone == "" &&
        this.email == "" &&
        this.website == "" &&
        this.images.length == 0
      ) {
        // We cannot go to the next page, as the user does not exist.
        this.error =
          "You must fill the information or upload a business card of the customer";
      } else {
        let flvis_id = this.$store.getters["visits/getCurrentVisitId"];
        if (flvis_id == 0) {
          await this.$store.dispatch("visits/visit_add", {
            first_name: this.first_name,
            last_name: this.last_name,
            company: this.company,
            phone: this.phone,
            email: this.email,
            website: this.website,
          });
        } else {
          var person = this.$store.getters["visits/getCurrentVisitPerson"];
          await this.$store.dispatch("visits/visit_edit_person", {
            flvisp_id: person.flvisp_id,
            flvisp_company: this.company,
            flvisp_first_name: this.first_name,
            flvisp_last_name: this.last_name,
            flvisp_phone: this.phone,
            flvisp_email: this.email,
            flvisp_website: this.website,
            image_data: "",
          });
        }
        var request_error = this.$store.getters["visits/getRequestError"];

        if (request_error != "") {
          this.error = request_error;
        } else {
          this.$emit("go_to_second", "go_to_items");
        }
      }
    },

    get_business_card() {
      this.status = "Camera";
      this.isCameraOpen = true;
      this.isPhotoTaken = false;
      this.createCameraElement();
    },

    cancelCamera() {
      this.stopCameraStream();
      this.status = "PersonInfo";
    },

    // toggleCamera() {
    //     if(this.isCameraOpen) {
    //         this.isCameraOpen = false;
    //         this.isPhotoTaken = false;
    //         this.isShotPhoto = false;
    //         this.stopCameraStream();
    //     } else {
    //         this.isCameraOpen = true;
    //         this.createCameraElement();
    //     }
    // },

    createCameraElement() {
      this.isLoading = true;

      // const constraints = (window.constraints = {
      //   audio: false,
      //   video: true,
      //   facingMode: 'user' // environment
      // });

      // navigator.mediaDevices
      //   .getUserMedia(constraints)
      //   .then((stream) => {
      //     this.isLoading = false;
      //     this.$refs.camera.srcObject = stream;
      //   })
      //   .catch((error) => {
      //     this.isLoading = false;
      //     alert(
      //       "May the browser didn't support or there is some errors." + error
      //     );
      //   });

      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
				this.camera_error = 'enumerateDevices is not supported.'
			} else {

        var object = this;

        this.listOfCameras = [];


        navigator.mediaDevices.enumerateDevices().then(async (devices) => {

            // Iterate over all the list of devices (InputDeviceInfo and MediaDeviceInfo)
            devices.forEach((device) => {
                // According to the type of media device
                switch(device.kind){
                    // Append device to list of Cameras
                    case "videoinput":
                        var option = {};
                        option.value = device.deviceId;
                        option.text = device.label;
                        object.listOfCameras.push(option);
                        break;
                }
                console.log(device);
            });

            // Create Helper to ask for permission and list devices
            object.MediaStreamHelper = {
              // Property of the object to store the current stream
              _stream: null,

              // Request user permissions to access the camera and video
              requestStream: function() {
                if (this._stream) {
                  this._stream.getTracks().forEach(track => {
                    track.stop();
                  });
                }

                const videoSource = object.listOfCameras[object.selectedCameraIndex].value;
                const constraints = {
                  video: {
                    deviceId: videoSource ? {exact: videoSource} : undefined
                  }
                };

                return navigator.mediaDevices.getUserMedia(constraints);
              }
            };

            // Check if we can activate the Rear camera on the fly
            var foundRear = false;

            if(object.firstUse==true){

              await navigator.mediaDevices.getUserMedia({video: {facingMode: {exact: 'environment'}}})
              .then(stream => {
                  foundRear = true;
                  object.MediaStreamHelper._stream = stream;
                  object.$refs.camera.srcObject = stream;
              }).catch(function(err){
                console.error('foundRear',err);
              });

            }

            if (foundRear==false) {

              if(object.firstUse==true){
                object.selectedCameraIndex = (object.listOfCameras.length-1);
              }

              object.MediaStreamHelper.requestStream().then(function(stream){
                // Store Current Stream
                object.MediaStreamHelper._stream = stream;
                // Play the current stream in the Video element
                object.$refs.camera.srcObject = stream;

              }).catch(function(err){
                console.error(err);
              });

            }


        }).catch(function (e) {
            console.log(e.name + ": " + e.message);
        });



      }

    },

    switchCamera(){
      this.firstUse = false;

      if(this.selectedCameraIndex<(this.listOfCameras.length-1))
        this.selectedCameraIndex++;
      else
        this.selectedCameraIndex = 0;

      this.createCameraElement();
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    async takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 1000;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      var width = this.$refs.camera.clientWidth;
      var height = this.$refs.camera.clientHeight;

      console.log(width,height);

      this.$refs.canvas.width = width;
      this.$refs.canvas.height = height;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, width, height);

      // get image from canvas
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg");

      // send image to server
      let flvis_id = this.$store.getters["visits/getCurrentVisitId"];
      console.log("flvis_id: " + flvis_id);

      if (flvis_id == 0) {
        await this.$store.dispatch("visits/visit_add_image", {
          image_data: canvas,
        });
      } else {
        var person = this.$store.getters["visits/getCurrentVisitPerson"];
        await this.$store.dispatch("visits/visit_edit_person", {
          flvisp_id: person.flvisp_id,
          flvisp_company: this.company,
          flvisp_first_name: this.first_name,
          flvisp_last_name: this.last_name,
          flvisp_phone: this.phone,
          flvisp_email: this.email,
          flvisp_website: this.website,
          image_data: canvas,
        });
      }
      var request_error = this.$store.getters["visits/getRequestError"];

      if (request_error != "") {
        this.error = request_error;
      } else {
        this.error = "";

        let person_info = this.$store.getters["visits/getCurrentVisitPerson"];
        console.log(person_info);
        let person_images = JSON.parse(person_info.flvisp_images);
        this.images = [];
        for (let i = 0; i < person_images.length; i++) {
          this.images.push(
            process.env.VUE_APP_API_IMAGES_ENDPOINT + person_images[i].filename
          );
        }
        // go back to next screen
        this.stopCameraStream();
        this.get_business_card_message = "+ Add Card";
        this.status = "PersonInfo";
      }
    },

    async removePhoto(image,index) {

      console.log(image,index);
      // send image to server
      let flvis_id = this.$store.getters["visits/getCurrentVisitId"];
      console.log("flvis_id: " + flvis_id);

      var person = this.$store.getters["visits/getCurrentVisitPerson"];
      await this.$store.dispatch("visits/visit_delete_image", {
        flvisp_id: person.flvisp_id,
        image_index: index,
      });

      var request_error = this.$store.getters["visits/getRequestError"];

      if (request_error != "") {
        this.error = request_error;
      } else {
        this.error = "";

        let person_info = this.$store.getters["visits/getCurrentVisitPerson"];
        console.log(person_info);
        let person_images = JSON.parse(person_info.flvisp_images);
        this.images = [];
        for (let i = 0; i < person_images.length; i++) {
          this.images.push(
            process.env.VUE_APP_API_IMAGES_ENDPOINT + person_images[i].filename
          );
        }
      }

    },

    // async downloadImage() {
    //     //const download = document.getElementById("downloadPhoto");
    //     const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg");
    //     //.replace("image/jpeg", "image/octet-stream");
    //     // download.setAttribute("href", canvas);

    //     console.log('Send image');

    // }

    emptyFields() {
      this.company = "";
      this.first_name = "";
      this.last_name = "";
      this.phone = "";
      this.email = "";
      this.website = "";
      this.images = [];
      this.get_business_card_message = "Take Photo of Business Card";
    },

    fillFields(){
      let person = this.$store.getters["visits/getCurrentVisitPerson"];
      this.company = person.flvisp_company;
      this.first_name = person.flvisp_first_name;
      this.last_name = person.flvisp_last_name;
      this.phone = person.flvisp_phone;
      this.email = person.flvisp_email;
      this.website = person.flvisp_website;
      if (person.flvisp_images != "" && person.flvisp_images != "null") {
        let person_images = JSON.parse(person.flvisp_images);
        this.images = [];
        for (let i = 0; i < person_images.length; i++) {
          this.images.push(
            process.env.VUE_APP_API_IMAGES_ENDPOINT + person_images[i].filename
          );
        }
        this.get_business_card_message = "+ Add Card";
      }

    }

  },

  mounted() {
    console.log("Visitor Mounted");
    let flvis_id = this.$store.getters["visits/getCurrentVisitId"];
    console.log("mounted flvis_id:" + flvis_id);
    if (flvis_id != 0) {
      var person = this.$store.getters["visits/getCurrentVisitPerson"];
      this.company = person.flvisp_company;
      this.first_name = person.flvisp_first_name;
      this.last_name = person.flvisp_last_name;
      this.phone = person.flvisp_phone;
      this.email = person.flvisp_email;
      this.website = person.flvisp_website;
      if (person.flvisp_images != "" && person.flvisp_images != "null") {
        let person_images = JSON.parse(person.flvisp_images);
        this.images = [];
        for (let i = 0; i < person_images.length; i++) {
          this.images.push(
            process.env.VUE_APP_API_IMAGES_ENDPOINT + person_images[i].filename
          );
        }
      }
      this.get_business_card_message = "+ Add Card";
    } else {
      this.emptyFields();
    }
  },
};
</script>

<style lang="scss" scoped>

.login_error {
  color: red;
  font-size: 15px;
}

ion-item {
  --padding-start: 0;
  --background-focused: transparent;
  --min-height: 65px;
}

/* ion-label {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-size: 14px !important;
}

ion-input {
  border: 1px solid #cbcbcb;
  border-radius: 3px;
  font-size: 14px;
  --padding-start: 10px !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
} */

  /* Form */

  ion-label {
    font-weight: bold;
  }

  ion-input {
    background: #fff;
    border-radius: 8px;
    padding: 5px 8px !important;
    margin: 10px 0;
  }

/* ion-row {
  margin-bottom: 5px;
} */

ion-col {
  --ion-grid-column-padding: 0 5px;
}

ion-list-header ion-label {
  margin-top: 16px;
}

.button_nav {
  border-radius: 0;
  height: 40px;
  width: 100px;
  color: #fff;
  --background: #E87E04;
}

/* Camera */

.camera_error {
  color: red;
  font-size: 15px;
}

.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-width: 98vw;
  height: 80vh;

  .camera-button {
    margin-bottom: 2rem;
  }

  .camera-box {
    .camera-shutter {
      opacity: 0;
      width: auto;
      height: 80vh;
      background-color: #fff;
      position: absolute;

      &.flash {
        opacity: 1;
      }
    }
  }

  .camera-shoot {
    margin: 1rem 0;
    width:100%;

/*     button {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      img {
        height: 35px;
        object-fit: cover;
      }
    } */
  }

  .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;

    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }

    .loader-circle {
      display: block;
      height: 14px;
      margin: 0 auto;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      transform: translateX(-50%);
      position: absolute;
      width: 100%;
      padding: 0;

      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }
  }

  @keyframes preload {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }




}
</style>